import React from 'react';
import {Anchor, Card, Icon, Text} from '@albert-io/atomic';
import {resource} from '@albert-io/json-api-framework/request/builder';
import sessionStore from 'client/Session/SessionStore';
import useMandarkQueries from 'lib/hooks/useMandarkQueries';
import {isUnlicensedTeacherOrAdmin} from 'lib/UserAccessUtil';

import {assignmentBuilderLink} from './DocumentContentDiscovery/AssignmentBuilderIntroModal/AssignmentBuilderIntroModal.react';
import './unlicensed-view.scss';

const UnlicensedAssignmentBuilderView = () => {
  return (
    <Card
      paddingLevel={5}
      className='cd-unlicensed-view__container u-mar-lr_auto u-mar-t_4 u-pad-lr_7 u-display_flex u-flex-direction_column'
    >
      <div className='cd-unlicensed-view__card u-bgc_slate-050 u-border-radius_1 u-pad_3 u-border-color_slate-300 u-border'>
        <Icon
          icon={['fal', 'triangle-exclamation']}
          size='standalone'
          className='u-mar-b_2 u-mar-t_1 u-color_slate-700 u-font-weight_bold'
        />
        <Text className='u-mar-b_2 u-color_slate-700' bold>
          You need a school license to access the Assignment Builder.
        </Text>
        <Text className='u-mar-b_2 u-color_slate-700'>
          If you&apos;d like access,
          <Anchor href='mailto:schools@albert.io'> email our team</Anchor> about upgrading your
          license or {` `}
          <Anchor
            target='_blank'
            href='https://albert-licenses.typeform.com/to/c0B01094?source=assignmentbuilder'
          >
            submit a request for more information.
          </Anchor>
        </Text>
      </div>
      <div className='u-mar-t_4 cd-unlicensed-view__card u-pad_2'>
        <Text className='u-mar-b_3 '>Learn more about the Assignment Builder:</Text>
        <iframe allowFullScreen title='Assignment Builder Intro' src={assignmentBuilderLink} />
        <div className='u-display_flex u-flex-direction_column u-mar-t_3'>
          <Text className='u-mar-b_0' as='p' size='s'>
            Need more guidance?
          </Text>
          <Text className='u-mar-b_0' as='p' size='s'>
            Read {` `}
            <Anchor target='_blank' href='https://help.albert.io/en/articles/8725620'>
              our step-by-step guide
            </Anchor>
          </Text>
        </div>
      </div>
    </Card>
  );
};

export default UnlicensedAssignmentBuilderView;

// pulled from marketplace/src/client/AccountSettings/Subscriptions/InstructionalLicenseCard.js ----
const getTeacherWithMetadataQuery = () => {
  return resource('teachers_v1')
    .mandarkEndpoint(['teachers_v1', sessionStore.getUserId()])
    .include('school_v5')
    .include('school_personnel_v1')
    .include('school_personnel_v1.school_v5')
    .withMeta('teacher_v1')
    .customQuery({
      meta: {
        context: {
          teacher: {
            license_info: true
          }
        }
      }
    });
};

const getHasAllSubjectsFromTeacher = (teacher) => {
  const liscences = teacher.getMeta().getSchoolLicensesInfo();
  const hasAllAccess = liscences.toArray().some((licenseInformation) => {
    const hasSchoolLicense = licenseInformation.get('has_school_license');
    const licenseStatus = licenseInformation.get('school_license_status');

    const activeLicenseAndApproved = hasSchoolLicense && licenseStatus === 'active';
    const hasAllSubjects = licenseInformation
      .get('school_license_subject_groups')
      ?.includes('All Subjects');
    return hasAllSubjects && activeLicenseAndApproved;
  });
  return hasAllAccess;
};
// -----------------------

export const showUnliscensedView = () => {
  const {
    isReady: isSubCheckLoaded,
    resources: [teacher]
  } = useMandarkQueries([getTeacherWithMetadataQuery()]);

  const {isReady: isUnlicensedCheckReady, value: isUnlicensedNonStudent} =
    isUnlicensedTeacherOrAdmin();

  const isReady = isSubCheckLoaded && isUnlicensedCheckReady;

  let value;
  if (isReady) {
    const hasAllAccess = getHasAllSubjectsFromTeacher(teacher);

    value = isUnlicensedNonStudent || !hasAllAccess;
  }

  return {
    isReady,
    value
  };
};
